import { Box, paletteColors, Typography } from '@evaneos/b2b-ui';

import { GoogleLogo } from '../../../design-system/SVG/GoogleLogo';
import { GoogleSignInButton } from '../../../design-system/GoogleSignInButton';

type Props = {
    onConnect: () => void;
};

export const AppointmentDisconnectedState = ({ onConnect }: Props): JSX.Element => (
    <Box
        data-spec-id="agenda-disconnected-state"
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}
    >
        <Box
            sx={{
                bgcolor: 'background.paper',
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 2,
                p: 3,
                width: 459,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 4,
            }}
        >
            {/* Logo + textes */}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 3,
                    width: '100%',
                }}
            >
                <Box
                    sx={{
                        bgcolor: paletteColors.neutral[100],
                        borderRadius: '100px',
                        width: 60,
                        height: 60,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <GoogleLogo size={32} />
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 1,
                        textAlign: 'center',
                    }}
                >
                    <Typography variant="h3" sx={{ fontWeight: 700, fontSize: 20 }}>
                        {/* @todo translate: agenda.disconnected.title */}
                        Activez la prise de RDV intégrée à Request Manager
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        {/* @todo translate: agenda.disconnected.description */}
                        Connectez votre Google Agenda pour proposer des créneaux à vos voyageurs et
                        synchroniser vos rendez-vous automatiquement.
                    </Typography>
                </Box>
            </Box>

            <div data-spec-id="agenda-connect-google-button">
                <GoogleSignInButton label="Connecter Google Agenda" onClick={onConnect} />
            </div>
        </Box>
    </Box>
);
